import React from 'react';

import { QuestionCircleIcon } from '@vlabs/icons';
import cn from 'classnames';

import st from './AttributeColor.module.sass';

const normalizeToArray = (value) => {
  if (!value) return [];
  return Array.isArray(value) ? value : [value];
};

export function AttributeColor({ value, tooltip, className }) {
  const colors = normalizeToArray(value);

  if (!colors.length) return null;

  const isUnknown = colors.length === 1 && colors[0] === 'undefined';

  if (isUnknown) {
    return (
      <span className={cn(st.UnknownIcon, className)}>
        <QuestionCircleIcon className={st.QuestionIcon} />
      </span>
    );
  }

  return (
    <span className={cn(st.AttributeColor, className)}>
      {colors.map((color, i) => (
        <span
          className={cn(st.ColorDot, st[`ColorDot_${color}`])}
          key={`${color}-${i}`}
        />
      ))}
    </span>
  );
}
